import { Component } from '@angular/core';
import { MatChipSelectionChange } from '@angular/material/chips';

import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

@Component({
  selector: 'app-product-allergenic-subform',
  templateUrl: './product-allergenic-subform.component.html',
  styleUrls: ['./product-allergenic-subform.component.scss'],
})
export class ProductAllergenicSubformComponent extends SubformBaseComponent {
  DICT_PATH = 'PRODUCTS';
  ALLERGENIC = 'PRODUCTS.ALLERGENIC.';

  allergenicFieldNamesAndTranslations = {
    gluten: 'GLUTEN',
    shellfish: 'SHELLFISH',
    eggs: 'EGGS',
    fish: 'FISH',
    peanuts: 'PEANUTS',
    soyabeans: 'SOYABEANS',
    milk: 'MILK',
    treeNuts: 'TREE_NUTS',
    celery: 'CELERY',
    mustard: 'MUSTARD',
    sesameSeeds: 'SESAME_SEEDS',
    sulphurDioxidAndSulphits: 'SULPHUR_DIOXID_AND_SULPHITS',
    lupin: 'LUPIN',
    molluscs: 'MOLLUSCS',
  };

  selectionChange(event: MatChipSelectionChange, key: string) {
    if (event.isUserInput) {
      this.group.controls[key]?.setValue(event.selected);
    }
  }
}
